export const PATIENT_PIN_LENGTH = 4 as const
